import { useVerifyQueryParamsAndConfirmEmail, useHandleUserSignatures } from "./hooks";
import { Loader } from "../../modules/loader";
import "./ClientSignScreen.style.css";
import { FilePreview } from "../../components/file-preview";
import { SplitPagesComponent } from "./SplitPagesComponent";
import { SignInstructionPanel } from "./SignInstructionPanel";
import {
  useIsSigningSelector,
  useFetchedDocumentSelector,
  useDocumentIsSuccessfullySignedSelector,
  useDocumentBlobUrlSelector,
} from "../../store/documents/DocumentSelector";
import { useTranslation } from "react-i18next";
import { WebHeader } from "./WebHeader";

export const ClientSignScreen = () => {
  const { isLoading, isError } = useVerifyQueryParamsAndConfirmEmail();
  const { handleStartSigning } = useHandleUserSignatures();
  const isSigning = useIsSigningSelector();
  const fetchedDocumentData = useFetchedDocumentSelector();
  const { t } = useTranslation();
  const documentIsSuccessfullySigned = useDocumentIsSuccessfullySignedSelector();
  const documentBlobUrl = useDocumentBlobUrlSelector();

  const isDocumentAlreadySigned = fetchedDocumentData?.digitalSignRequest?.status === "signed";

  if (isLoading)
    return (
      <>
        <WebHeader />
        <div className="d-flex justify-content-center loader-container">
          <Loader color="primary" size="l" />
        </div>
      </>
    );

  if (isError)
    return (
      <>
        <WebHeader />
        <div className="d-flex justify-content-center align-items-center error-container">
          <div className="text-center">
            <h2 className="mb-5">Verification Failed</h2>
            <p>
              Please contact our operator for more information at <strong>0001 7600 23</strong>
            </p>
          </div>
        </div>
      </>
    );

  if (isDocumentAlreadySigned || documentIsSuccessfullySigned) {
    return (
      <>
        <WebHeader />
        <div className="d-flex justify-content-center align-items-center already-signed-container">
          <div className="text-center">
            <h2 className="mb-4">{t("WEB_DIGITAL_SIGNATURE.ALREADY_SIGNED_TITLE")}</h2>
            <p>{t("WEB_DIGITAL_SIGNATURE.ALREADY_SIGNED_MESSAGE")}</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <WebHeader />
      {fetchedDocumentData ? (
        <div className="preview-container">
          <div className="pages-container">
            {isSigning ? (
              <SplitPagesComponent />
            ) : (
              <div
                style={{
                  position: "sticky",
                  top: 128,
                  maxWidth: 800,
                  margin: "0 auto",
                }}
              >
                <FilePreview
                  enableCanceling={false}
                  enableEditing={false}
                  type={fetchedDocumentData.files?.[0]?.mimeType ?? ""}
                  url={documentBlobUrl ?? ""}
                  name={fetchedDocumentData.files?.[0]?.name ?? ""}
                  width={800}
                  height={800}
                />
              </div>
            )}
          </div>

          <div className="signature-panel">
            {!isSigning ? (
              <button
                onClick={handleStartSigning}
                style={{
                  width: "100%",
                  height: 50,
                  fontSize: 16,
                  cursor: "pointer",
                  borderRadius: 4,
                  border: "none",
                  backgroundColor: "#00264d",
                  color: "#fff",
                }}
              >
                {t("WEB_DIGITAL_SIGNATURE.SIGN_DOCUMENT")}
              </button>
            ) : (
              <SignInstructionPanel />
            )}
          </div>
        </div>
      ) : null}
    </>
  );
};
